module.exports = __webpack_public_path__ + "static/giant_spider-cd154e0b14309deb2a3a54f4bbbc6b7e.jpg";